import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ApiPartnerService } from "@app/api/api-partner.service";
import swal from "sweetalert/dist/sweetalert.min.js";

declare var $: any;

@Component({
  selector: "adminnextsys-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.css"],
})
export class CgmnNotificationComponent implements OnInit {

  @ViewChild("closeBtn", { static: false }) closeBtn: ElementRef;
  @ViewChild('stbSelect', { static: false })
  stbSelect: ElementRef;

  /* ===================== TABLE ===================== */
  listNotifications: any[] = [];
  listTemplates: any[] = [];
  listPartners: any[] = [];
  listPartnerSTB: any[] = [];
  selected_sn: string = '';
  table_load = true;

  paging: any = {};
  page_self: any = [];
  page_next: any = [];
  page_prev: any = [];
  meta: any = [];

  last_index: number;
  first_index: number;
  total_count: number;

  /* ===================== SEARCH ===================== */
  querySearch = false;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";

  limit = 10;
  msearch: string;
  textSearch = new FormControl("");

  /* ===================== ACTION ===================== */
  alert_act: "add" | "view";
  message: string;
  itemset: any = {};

  /* ===================== FORM ===================== */
  formSet = this.fb.group({
    title: ["", Validators.required],
    template_id: [""],
    partner_id: [""],
    message_type: ["", Validators.required],
    message: ["", Validators.required],
    sn: [[]],
    flag_active: [1],
  });

  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loadStart();
    this.loadMessageTemplate();
    this.loadPartner();
  }

  /* ===================== UTIL ===================== */

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  alertsx(message: string) {
    swal({
      title: "Success!",
      text: message,
      icon: "success",
    });

    setTimeout(() => {
      this.loadStart();
    }, 800);
  }

  alertfx(message: string) {
    swal({
      title: "Failed!",
      text: message,
      icon: "error",
    });
  }

  trackByFn(index: number): number {
    return index;
  }

  initSTBSelect2(): void {
    const el = this.stbSelect.nativeElement;

    if ($(el).data('select2')) {
      $(el).off().select2('destroy');
    }

    $(el).select2({
      placeholder: 'Select STB',
      width: '100%',
      closeOnSelect: false
    });

    $(el).on('change', () => {
      const raw = $(el).val() || [];
      const values = Array.isArray(raw) ? raw : Object.values(raw);

      // 🔥 SATU-SATUNYA TEMPAT SET VALUE
      this.formSet.get('sn').setValue(values);
      this.selected_sn = values.join(', ');
    });
  }

  selectAllSTB(): void {
    const allSn = this.listPartnerSTB.map(s => s.sn);
    $(this.stbSelect.nativeElement).val(allSn).trigger('change');
  }

  clearAllSTB(): void {
    $(this.stbSelect.nativeElement).val(null).trigger('change');
  }

  /* ===================== LOAD & SEARCH ===================== */

  loadStart() {
    this.route.queryParams.subscribe((params) => {
      this.currentParams = params;
      this.queryParams = "?" + this.queryStr(params);
      this.loadNotifications(this.queryParams);
    });
    this.msearch = undefined;
  }

  refreshPage() {
    this.ngOnInit();
  }

  search() {
    this.querySearch = true;

    if (this.msearch === undefined) {
      this.msearch = "";
    }

    this.searchQueryParams =
      "?page=" +
      this.page_self["page"] +
      "&search=" +
      this.msearch +
      "&limit=" +
      this.limit;

    this.loadNotifications(this.searchQueryParams);
  }

  loadNotifications(params: any) {
    this.table_load = true;

    this.partnerService.GetNotifList(params).subscribe((output: any) => {
      this.listNotifications = output.data;
      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;

      this.total_count = this.meta.totalCount;
      let self = this.page_self.page;

      if (self * this.meta.perPage < this.meta.totalCount) {
        this.last_index = self * this.meta.perPage;
      } else {
        this.last_index = this.meta.totalCount;
      }
      this.first_index = (self - 1) * this.meta.perPage + 1;
    });
  }

  loadMessageTemplate() {
    this.partnerService.GetMessageTemplates('?flagActive=1').subscribe((output: any) => {
      this.listTemplates = output.data;
    });
  }

  loadPartner() {
    this.partnerService.GetListNextsysPartner('?limit=10000').subscribe((output: any) => {
      this.listPartners = output.data;
    });
  }

  loadPartnerSTB(partner_id: number) {
    this.partnerService
      .GetViewPartnerSTBNextsys(partner_id, '?limit=10000')
      .subscribe((output: any) => {
        this.listPartnerSTB = output.data;

        setTimeout(() => {
          this.initSTBSelect2();
          this.formSet.get('sn').setValue([]);
          this.selected_sn = '';
        });
      });
  }

  /* ===================== ACTION ===================== */

  onActionClick(act: "add" | "view", item: any = null) {
    this.alert_act = act;
    console.log(item);
    if (act === "add") {
      this.clearForm();
    }
  }

  onTemplateChange() {
    const control = this.formSet.get('template_id');

    if (!control) {
      return;
    }

    const templateId = control.value;

    const selectedTemplate = this.listTemplates.find(
      t => t.id === Number(templateId)
    );

    if (selectedTemplate) {
      this.formSet.patchValue({
        title: selectedTemplate.title,
        message: selectedTemplate.message,
        message_type: selectedTemplate.type
      });
    }
  }

  onPartnerChange() {
    const control = this.formSet.get('partner_id');

    if (!control) {
      return;
    }

    const partnerId = control.value;

    const selectedPartner = this.listPartners.find(
      p => p.id === Number(partnerId)
    );

    if (selectedPartner) {
      this.loadPartnerSTB(selectedPartner.id);
    }
  }

  clearForm() {
    this.formSet.reset();
    this.formSet.get("flag_active").setValue(1);
    this.formSet.get("sn").setValue([]);
    this.selected_sn = '';
  }
  /* ===================== SUBMIT ===================== */

  submitAdd() {
    this.partnerService
      .PostNotification(this.formSet.value)
      .subscribe((output: any) => {
        if (output.status) {
          this.message = output.message;
          this.alertsx(this.message);
          this.closeModal();
        } else {
          this.alertfx(output.message);
        }
      });
  }
}
